const roles = {
  supplier: ["admin-supplier", "vendor-supplier"],
  customer: ["admin-customer", "customer"],
};

// Constantes adicionales para roles individuales
const ROLES = {
  ADMIN_SUPPLIER: "admin-supplier",
  VENDOR_SUPPLIER: "vendor-supplier",
  ADMIN_CUSTOMER: "admin-customer",
  CUSTOMER: "customer",
  VENDOR: "vendor",
};

// Constantes para roles principales
const MAIN_ROLES = {
  SUPPLIER: "supplier",
  CUSTOMER: "customer",
};

export default roles;
export { ROLES, MAIN_ROLES };
